import { LanguageIcon } from "@heroicons/react/24/outline"
import { addFieldEditor } from "aldoo-ra/CMS/field-editor-resolver"
import LanguagesField from "./LanguagesField"

/**
 * Languages extension (admin side): the languages the product's content is
 * available in. The server half is aldoo-na/store/product/extensions/languages.
 */
addFieldEditor("LanguagesField", LanguagesField)

export const StoreProductExtension = {
  id: "languages",
  label: "Languages",
  description: "The languages the product content is available in",
  icon: LanguageIcon,
  group: { id: "languages", label: "Languages", description: "The languages the product's content is available in." },
  fields: [{ id: "languages", label: "Languages", type: "Array", fieldEditor: "LanguagesField", description: "The languages the content exists in", render: { variant: "default" } }],
}
